import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapMutations } from 'vuex';
import mixinActionBoxStyles from '../../components/core/mixinActionBoxStyles';
import get from 'lodash/get';
import overviewEditMixin from '../../components/core/dtwin/overviewEditMixin';
import EditMixin from '../../components/core/dtwin/editMixin';
import GeoDataMixin from '../../components/core/dtwin/geoDataMixin';

var defaultTab = function defaultTab(ctx) {
  if (ctx.$route.query.stateId) {
    return 'tab-states';
  }

  if (ctx.$route.query.ruleId) {
    return 'tab-rules';
  }

  if (ctx.$route.query.dashboard !== undefined) {
    return 'tab-dashboard';
  }

  return 'tab-main';
};

export default {
  name: 'ViewDigitalTwinDigitalTwinDetails',
  mixins: [EditMixin, GeoDataMixin, mixinActionBoxStyles, overviewEditMixin],
  data: function data() {
    return {
      twinSelectionTreeMenu: true,
      pageYOffset: 0,
      tabItem: defaultTab(this),
      shouldOpenStateDetail: !!this.$route.query.stateId
    };
  },
  computed: {
    headerBG: function headerBG() {
      if (get(this.twinObject, 'data.twinImageId')) {
        return "".concat(process.env.VUE_APP_API_HOST).concat(process.env.VUE_APP_API_PATH, "/upload/").concat(this.twinObject.data.twinImageId);
      }

      return null;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    hasDependentDevices: function hasDependentDevices() {
      return this.twinDependencies && this.twinDependencies.virtualDevices && this.twinDependencies.virtualDevices.length > 0;
    }
  },
  watch: {
    twinDataStates: function twinDataStates() {
      if (this.twinDataStates.length) {
        if (this.shouldOpenStateDetail && this.$refs['stateTable']) {
          this.finishedLoadingStatesTable();
        }
      }
    },
    $route: function $route() {
      // the component is not reloaded/re-mounted if the twin-id in the route changes
      // so perform the setup again for a different route; i.e. swap out the displayed details on-the-fly
      this.teardownDtwinSocket();
      this.setup();

      if (get(this.$route, 'query.stateId')) {
        this.tabItem = 'tab-states';
      } else if (get(this.$route, 'query.ruleId')) {
        this.tabItem = 'tab-rules';
      }
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.saveScrollOffset);
    this.setup();
  },
  destroyed: function destroyed() {
    window.removeEventListener('scroll', this.saveScrollOffset);
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('app', ['snackbar'])), {}, {
    digitalTwinChanged: function digitalTwinChanged(selection) {
      if (parseInt(selection.id) !== parseInt(this.$route.params.id)) {
        this.$router.push("/digitaltwin-mgmt/".concat(selection.id));
        this.twinSelectionTreeMenu = false;
      }

      this.twinSelectionTreeMenu = false;
    },
    breadCrumbsPath: function breadCrumbsPath() {
      var ancestorList = this.ancestorList();

      if (ancestorList.length) {
        return ancestorList.map(function (a) {
          return {
            to: "/digitaltwin-mgmt/".concat(a.id),
            text: a.title
          };
        });
      }

      return [{
        to: '/digitaltwin-mgmt',
        text: this.$i18n_t('Common.drawer.dTwins')
      }];
    },
    saveScrollOffset: function saveScrollOffset() {
      this.pageYOffset = window.pageYOffset;
    },
    finishedLoadingStatesTable: function finishedLoadingStatesTable() {
      var _this = this;

      if (this.$route.query.stateId) {
        this.$nextTick(function () {
          var state = _this.twinDataStates.find(function (s) {
            return s.id === parseInt(_this.$route.query.stateId);
          });

          if (state) {
            _this.shouldOpenStateDetail = false;

            _this.$refs['stateTable'].editState(state);
          }
        });
      }
    },
    didUpdateStates: function didUpdateStates() {
      this.refreshStates();
    },
    dialogDisable: function dialogDisable() {
      this.dtwinToggleState();
    },
    prepareSubmit: function prepareSubmit() {
      this.handleSubmit();
    }
  })
};